import Link from './link';
export { softLinks } from './link';
export default Link;